import { useState } from 'react';

import { usePortalLocale } from '@/lib/i18n/PortalLocaleContext';

interface UserErrorNoticeProps {
  message: string;
  reference?: string;
  className?: string;
}

export function UserErrorNotice({
  message,
  reference,
  className = '',
}: UserErrorNoticeProps) {
  const { t } = usePortalLocale();
  const [showReference, setShowReference] = useState(false);

  return (
    <section
      className={`select-none rounded-2xl border border-brand-coral/40 bg-wash-coral px-5 py-4 text-left ${className}`}
      role="alert"
      aria-live="assertive"
      onDoubleClick={reference ? () => setShowReference((visible) => !visible) : undefined}
    >
      <p className="text-[13px] font-semibold leading-5 text-ink">{t(message)}</p>
      {reference && showReference && (
        <code className="mt-3 block select-all border-t border-brand-coral/20 pt-2 font-mono text-[11px] text-slate2/75">
          {reference}
        </code>
      )}
    </section>
  );
}
